<template>
  <div id='teamEdit'>
    <div class="content-title">
      <Icon type="android-settings"></Icon>檢視/修改
      <div class="border"></div>
    </div>
    <teamForm ref="teamForm"></teamForm>
    <Modal
        v-model="delModal"
        @on-ok="del" class="text-center">
        <Icon type="information-circled" size="36" color="#ff9900"></Icon>
        <span class="text-center fontsize26">確定要刪除此筆資料？</span>
    </Modal>
    <div class="text-center">
      <Button type="primary" @click="edit" v-if="disabled">編輯</Button>
      <Button type="primary" @click="save" v-else-if="!disabled">儲存</Button>
      <Button type="error" @click="showDel" >刪除</Button>
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/config";
import teamForm from "./teamForm"

export default {
  name: "teamEdit",
  components: {
    teamForm
  },
  data() {
    return {
      id: this.$route.params.id,
      disabled: true,
      delModal: false,
      formItem: {}
    };
  },
  methods: {
    edit () {
      this.$refs.teamForm.openEdit()
      this.disabled = false
    },
    async save () {
      let validate = this.$refs.teamForm.validate()
      if(!validate) return;
      this.disabled = true
      this.$refs.teamForm.closeEdit()
      this.formItem = this.$refs.teamForm.getFormItem()
      this.formItem.manager_company = this.formItem.name;
      this.axios.put(API.teams + this.id, this.formItem)
        .then(res => {
          this.$Message.info('儲存成功')
        })
        .catch(err => {
          console.log(err)
          this.errorHandle(err)
          this.$Message.info('儲存失敗')
          this.disabled = false
          this.$refs.teamForm.openEdit()
        })
    },
    showDel() {
      this.delModal = true;
    },
    async del () {
      await this.axios.delete(API.teams + this.id)
        .then(res => {
          this.$Message.info('刪除成功')
        })
        .catch(err => {
          console.log(err)
          this.$Message.info('刪除失敗')
        })
      this.$router.push({name: 'teamList'})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/team/teamEdit.vue